module.exports = __webpack_public_path__ + "static/media/WA_Logo.2627d03a.svg";